import { z } from "zod";

export const VoucherTemplateSchema = z
  .object({
    name: z.string().nullable(),
    marketingDescription: z.string().nullable(),
    uuid: z.string(),
    priceInCents: z.number().positive(),
    valueInCents: z.number().positive(),
  })
  .transform((data) => ({
    ...data,
    price: data.priceInCents / 100,
    value: data.valueInCents / 100,
  }));

export const VoucherTemplatesSchema = z.array(VoucherTemplateSchema);
export type VoucherTemplate = z.infer<typeof VoucherTemplateSchema>;
